// Tierarten als Daten (Architektur-Regel 4): Größe, Geschwindigkeit, Modellkennung und Produkte
// mit Taste und Wartezeit. Eine neue Art ist ein Eintrag in SPECIES und ein Modell im Client,
// kein Code im Kern.

import type { ItemId } from '../inventory/items.js';

export interface ProductDef {
  /** Was das Tier abgibt, z. B. 'milch'. */
  item: ItemId;
  /** Beschriftung der Handlung im Hinweis, z. B. 'Melken'. */
  action: string;
  /** Taste als KeyboardEvent.code, z. B. 'KeyE'. */
  key: string;
  /** Wartezeit in Sekunden Simulationszeit, bis das Produkt wieder bereit ist. */
  cooldownSeconds: number;
}

export interface Species {
  id: string;
  /** Anzeigename, z. B. 'Kuh'. */
  name: string;
  /** Breite quer zur Blickrichtung, in Blöcken. */
  width: number;
  /** Höhe vom Fußpunkt, in Blöcken. */
  height: number;
  /** Länge in Blickrichtung, in Blöcken. */
  length: number;
  /** Gehgeschwindigkeit in Blöcken je Sekunde. */
  walkSpeed: number;
  /** Kennung des Blockmodells im Client. */
  model: string;
  products: ProductDef[];
}

/** Alle bekannten Tierarten nach id; Schlüssel und `id` stimmen überein. */
export const SPECIES: Readonly<Record<string, Species>> = {
  kuh: {
    id: 'kuh',
    name: 'Kuh',
    width: 0.9,
    height: 1.4,
    length: 1.6,
    walkSpeed: 1.2,
    model: 'kuh',
    products: [{ item: 'milch', action: 'Melken', key: 'KeyE', cooldownSeconds: 60 }],
  },
};

/**
 * Die Tierart zu `id`. Eine unbekannte Art ist ein Fehler mit klarer Meldung, damit ein Tippfehler
 * im Dorf-Bauplan sofort auffällt und nicht als stumme Kuh endet. `table` ist standardmäßig
 * SPECIES; Tests geben eine eigene Tabelle mit, um weitere Arten ohne Änderung am Kern zu tragen.
 */
export function getSpecies(id: string, table: Readonly<Record<string, Species>> = SPECIES): Species {
  const species = table[id];
  if (species === undefined) {
    const bekannt = Object.keys(table).join(', ') || '(keine)';
    throw new Error(`Unbekannte Tierart „${id}“. Bekannt: ${bekannt}.`);
  }
  return species;
}
